<div *ngIf="label" class="app-tag flex-center-center app-tag-content" [ngClass]="(tag?.tagType === 'partWarranties' || tag?.tagType === 'warrantyNo')
&& 'pointer'" tooltipStyleClass="itemstatus-tooltip" [escape]="false" tooltipPosition="top"
  [pTooltip]="tag?.tooltip || label"
  [ngStyle]="{color: textColor, backgroundColor: tagColor?.length === 7? tagColor : 'var(--primary-500)' , fontSize: fontSize + 'px', height: tagHeight ? tagHeight + 'px': '' }">
  <span id="add-{{id}}" class="app-tag-label tag-label" [ngClass]="{'truncate': textTruncate}">{{label}}</span>

  <i *ngIf="!nonRemoveAbleTagsType.includes(tag?.tagType) && isDeletable && !systemSpecificTags.includes(label)"
    id="remove-{{id}}" class="fal fa-times app-tag-delete font-white pointer" (click)="onDelete($event)"></i>
</div>